/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import Div100vh from "react-div-100vh";
import { Link, useHistory, useLocation } from "react-router-dom";
import FileSvg from "../../../../assets/images/despacho.svg";
import CheckSvg from "../../../../assets/images/image-check.svg";
import LogoutSvg from "../../../../assets/images/logout.svg";
import SearchSvg from "../../../../assets/images/lupa.svg";
import ReubicationSvg from "../../../../assets/images/reubication-icon.svg";
import Loading from "../../../components/shared/Loading";
import {
  default as MessageModal,
  default as SimpleModal,
} from "../../../components/shared/MessageModal";
import ProviderServices from "../../../services/ProviderServices";
import AuthService from '../../../services/AuthService';
import HomeSelect from "../HomeSelect";
import "./Home.scss";

function Home() {
  const [modalUbication, setModalUbication] = useState(false);
  const [loading, setLoading] = useState(false);
  const [plate, setPlate] = useState("");
  const [operator, setOperator] = useState(null);
  const [pickupPoint, setPickupPoint] = useState(null);
  const [modalCancel, setModalCancel] = useState(false);
  const [currentScreen, setCurrentScreen] = useState(0);
  const [alertSessionAct, setAlertSession] = useState(false);
  const [path, setPath] = useState("");
  const history = useHistory();
  const location = useLocation();
  let { from } = location.state || { from: { pathname: "/" } };
  console.log(from, "============ FROM");
  const user = JSON.parse(localStorage.getItem("userappret"));

  useEffect(() => {
    if (location.state && location.state.operator) {
      setOperator(location.state.operator);
      setPath(location.state.from);
      setCurrentScreen(2);
    }
  }, []);

  const logout = async () => {
    try {
      setLoading(true);
      const receptionSession = JSON.parse(
        localStorage.getItem("receptionSession")
      );
      const token = JSON.parse(localStorage.getItem('userappret')).token;
      if (receptionSession) {
        const response = await ProviderServices.deleteSession(
          receptionSession.sessionId
        );
        localStorage.removeItem("receptionSession");
        console.log(response);
      }
      const responseLogout = await AuthService.logout(token);
      setLoading(false);
      localStorage.clear();
      window.location.href = '/login';
    } catch (error) {
      setLoading(false);
      localStorage.removeItem("userappret");
      history.push(from);
      console.error(error);
    }
  };

  const saveData = (selectedPickup) => {
    const user = JSON.parse(localStorage.getItem("userappret"));
    user.title = selectedPickup.title;
    user.address = selectedPickup.address;
    user.operatorId = operator.id;
    user.pickupPointId = selectedPickup.id;
    user.operatorImage = operator.image;
    user.operator = operator;
    localStorage.setItem("userappret", JSON.stringify(user));
    return history.push(`/${path}`);
  };

  const handlePendingSession = () => {
    setAlertSession(true);
    const user = JSON.parse(localStorage.getItem("userappret"));
    const receptionSession = JSON.parse(
      localStorage.getItem("receptionSession")
    );
    user.pickupPointId = receptionSession.pickupPointId;
    user.title = receptionSession.title;
    localStorage.setItem("userappret", JSON.stringify(user));
    setTimeout(() => {
      history.push("/recepcion", { activeTab: receptionSession.activeTab });
    }, 2500);
  };

  const openModalUbications = (pathTo) => {
    setPath(pathTo);
    setCurrentScreen(1);
  };

  const renderOptions = () => {
    let options = [];
    const { roleName } = user;
    // const receptionSession = JSON.parse(localStorage.getItem('receptionSession'))
    // console.log(receptionSession, '================ RECEPCTION')
    if (roleName.includes("carrier")) {
      options.push(
        <div
          key="reception-option"
          className="home-option"
          // onClick={() =>
          //   receptionSession
          //     ? handlePendingSession()
          //     : openModalUbications('recepcion')
          // }
          onClick={() => openModalUbications("recepcion")}
        >
          <Option
            image={FileSvg}
            imageClass="img-file"
            text="DESPACHO DE PEDIDOS"
          />
        </div>
      );
    }
    if (roleName.includes("pickuppointop")) {
      options.push(
        <Link
          key="delivery-option"
          className="home-option"
          style={{ textDecoration: "none" }}
          to="/entrega"
        >
          <Option
            image={CheckSvg}
            imageClass="img-check"
            text="ENTREGA DE PEDIDOS"
          />
        </Link>
      );
    }

    if (roleName.includes("pickuppointop") || roleName.includes("carrier")) {
      options.push(
        <div
          key="consulta-option"
          className="home-option"
          onClick={() =>
            roleName.includes("carrier")
              ? openModalUbications("consulta")
              : history.push("/consulta")
          }
        >
          <Option
            image={SearchSvg}
            imageClass="img-lupa"
            text="CONSULTA DE PEDIDOS"
          />
        </div>
      );
    }

    if (roleName.includes("carrier")) {
      options.push(
        <div
          key="reubicacion-option"
          className="home-option"
          onClick={() =>
            roleName.includes("carrier")
              ? // false
                openModalUbications("reubicacion")
              : history.push("/reubicacion")
          }
        >
          <Option
            image={ReubicationSvg}
            imageClass="img-check"
            text="REUBICACIÓN DE PRODUCTOS"
          />
        </div>
      );
    }

    return options;
  };

  const renderScreen = () => {
    switch (currentScreen) {
      case 1:
        return (
          <HomeSelect
            // plate={plate}
            title={"Operadores"}
            type={1}
            onBack={() => {
              setModalCancel(true);
            }}
            onFinish={(operator) => {
              setOperator(operator);
              setCurrentScreen(2);
            }}
            key={1}
          />
        );
      case 2:
        return (
          <HomeSelect
            title={"Puntos de retiro"}
            // plate={plate}
            type={2}
            operator={operator}
            onBack={() => setCurrentScreen(1)}
            onFinish={(selectedPickup) => {
              setPickupPoint(selectedPickup);
              setModalUbication(false);
              saveData(selectedPickup);
            }}
            key={2}
          />
        );
      default:
        return (
          <>
            <div className="home-background"></div>
            <div className="home-container">
              <h2>¡Bienvenido!</h2>
              <h3>¿Qué deseas hacer?</h3>
              <div className="home-options-container">{renderOptions()}</div>
            </div>
            <div onClick={logout} className="exit">
              <img src={LogoutSvg} alt="salir" />
              <div>CERRAR SESIÓN</div>
            </div>
          </>
        );
    }
  };

  return (
    <Div100vh className="mobile-container">
      <Loading visible={loading} />
      <SimpleModal
        visible={alertSessionAct}
        message="Tiene una sesión pendiente, porfavor termina la sesión para poder crear otra"
        type={1}
      />
      <MessageModal
        visible={modalCancel}
        txtBtn1="SALIR"
        onClickBtn1={() => {
          setModalCancel(false);
          setModalUbication(false);
          setCurrentScreen(0);
        }}
        txtBtn2={"CONTINUAR"}
        onClickBtn2={() => {
          setModalCancel(false);
        }}
        type={10}
        closeModal={() => setModalCancel(false)}
        title={"¿Seguro que deseas salir?"}
      >
        <div className="modal-warning-message">
          <p>
            El operador seleccionado <span>no será guardado</span> una vez que
            regreses al menú principal.
          </p>
        </div>
      </MessageModal>
      {renderScreen()}
    </Div100vh>
  );
}

const Option = ({ image, text, imageClass }) => (
  <div className="option-container">
    <img src={image} alt="opcion" className={imageClass} />
    <h4>{text}</h4>
  </div>
);

export default Home;
